import { gql } from '@apollo/client';

export const GET_ROSTERS_BY_IDS = gql`
  query getRostersByIds($rosterIds: [String!]!) {
    rostersByIds(rosterIds: $rosterIds) {
      groupId
      worldTennisTeamNumbers {
        type
        average
      }
    }
  }
`;
